<template>
    <app-layout>
        <template #header>
            <h2 class="title">
                Available Payment Terms
            </h2>
            <flash-messages />
        </template>

        <div class="py-2">
            <div>
                <div class="bg-white p-3">
      <table class="table table-striped">
        <tr>
          <th>Weeks</th>
          <th>Down Payment</th>
        </tr>
        <tr v-for="term in terms" :key="term.id">
          <td>
            {{ term.weeks }}
          </td>
          <td>
            {{ term.down_payment_percent }}%
          </td>
        </tr>
    </table>

                        <h3>New Term</h3>
                        <div>
                        <label for="weeks">Weeks (2-12)</label><input id="weeks" type="text" v-model="form.weeks" size="2"/>
                    </div>
                        <div>
                        <label for="down_payment_percent">Down Payment</label><input id="down_payment_percent" type="text" v-model="form.down_payment_percent" size="3"/>%
                    </div>
        
                </div>

       <div class="bottom-button">
         <jet-button class="px-5" btnStyle="success" icon="fas fa-plus" :disable="form.processing" @click="addTerm()">Add Term</jet-button>
        </div>

            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import FlashMessages from '@/Shared/FlashMessages'
  
    export default {
        components: {
            AppLayout,
            FlashMessages,
        },
      props: {
        terms: Array,
      },
  data() {
    return {
      form: this.$inertia.form({
        weeks: null,
        down_payment_percent: null
    }),

    }
  },
    mounted() {
    },
  methods: {
    async addTerm() {

        this.form.post(this.route('user.addTerm'));

    }
  },
    }
</script>

<style>

    .gallery-thumbnail img {
        width: 120px;
    }

</style>